module.exports = __webpack_public_path__ + "static/media/warbler1.f9ec3a26.jpg";